<template>
  <div>
    <form @submit.prevent>
      <div class="row d-flex m-0">
        <div class="form-title flex-1-0">Danh sách nhóm người dùng</div>
        <div class="">
          <div
            class=""
            v-if="!readonly && chiTietNguoiDung.userCanBoDepartmentId"
          >
            <base-button
              class="btn search-information-btn d-block mr-2"
              button="Thêm nhóm người dùng"
              v-if="
                hasPermissionUser(
                  PERMISSION_NAME.NHOM_NGUOI_DUNG.THEM_NGUOI_DUNG
                )
              "
              @click="moFormThemDanhSachGroup()"
            >
              Thêm nhóm người dùng
            </base-button>
            <base-button
              :disabled="selectedGroup.length === 0"
              class="btn search-information-btn d-block"
              button="Xóa nhóm người dùng đã chọn"
              v-if="
                hasPermissionUser(
                  PERMISSION_NAME.NHOM_NGUOI_DUNG.XOA_NGUOI_DUNG
                )
              "
              @click="moFormXoaDanhSachGroup()"
            >
              Xóa nhóm người dùng đã chọn
            </base-button>
          </div>
        </div>
      </div>
      <div class="box-form-result">
        <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
        <DataTable
          :loading="isLoadingTable"
          :value="danhSachGroupNoiBo"
          :selection.sync="selectedGroup"
          dataKey="id"
          class="p-datatable-customers"
        >
          <template #empty
            ><div class="text-center">Không có dữ liệu</div></template
          >
          <template #loading
            ><div class="text-center">Đang tải dữ liệu ...</div>
          </template>
          <Column
            v-if="!readonly"
            field="id"
            headerStyle="width: 40px"
            header=""
            bodyStyle="text-align: center"
            selectionMode="multiple"
          >
          </Column>
          <Column
            field="stt"
            dataKey="stt"
            headerStyle="width: 40px"
            headerClass="p-2"
            header="STT"
            bodyStyle="text-align: center"
          >
            <template #filter> </template>
            <template #body="slotProps">
              <span>{{
                (requestInformation.pageIndex - 1) *
                  requestInformation.pageSize +
                slotProps.index +
                1
              }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="name"
            header="Tên nhóm"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestInternalForm.Name"
                @change="layDanhSachGroup"
              />
            </template>
            <template #body="slotProps">
              <span>{{ slotProps.data.name }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="code"
            header="Mã nhóm"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestInternalForm.Code"
                @change="layDanhSachGroup"
              />
            </template>
            <template #body="slotProps">
              <span>{{ slotProps.data.code }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="description"
            header="Mô tả"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestInternalForm.Description"
                @change="layDanhSachGroup"
              />
            </template>
            <template #body="slotProps">
              <span>{{ slotProps.data.description }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="appName"
            header="Ứng dụng"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestInternalForm.AppName"
                @change="layDanhSachGroup"
              />
            </template>
            <template #body="slotProps">
              <div v-html="slotProps.data.appName"></div>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="thaoTac"
            header="Thao tác"
            headerStyle="width: 100px"
            v-if="
              !readonly &&
              hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.XOA_NGUOI_DUNG)
            "
          >
            <template #body="slotProps">
              <div class="text-center">
                <font-awesome-icon
                  icon="trash-alt"
                  v-b-popover.hover.top="'Xóa nhóm'"
                  class="cursor-pointer color-red ml-2"
                  @click="moFormXoaGroup(slotProps.data.id)"
                />
              </div>
            </template>
          </Column>
        </DataTable>
        <BasePagination
          class="mt-3"
          :current-page="requestInformation.pageIndex"
          :total-pages="totalPages"
          :total-rows="totalRows"
          @changeNum="onChangeNum($event)"
          @changePages="onChangePages($event)"
        />
      </div>
    </form>
    <XoaGroupThuocNguoiDungModal
      @xoaDanhSachGroupThuocNguoiDung="xoaDanhSachGroupThuocNguoiDung"
    />
    <b-modal
      id="them-group-nguoi-dung-modal"
      size="xl"
      title="Thêm nhóm người dùng cho người dùng"
      :hide-footer="true"
    >
      <DanhSachGroupKhongThuocNguoiDung
        ref="danhSachGroupKhongThuocNguoiDung"
        @themGroupVaoNguoiDungThanhCong="themGroupVaoNguoiDungThanhCong"
        :key="`group-khong-thuoc-nguoi-dung-${nguoiDungId}`"
        :chiTietNguoiDung="chiTietNguoiDung"
        :appId="appId"
        @laydanhSachGroupTheoNguoiDung="layDanhSachGroup"
      />
    </b-modal>
  </div>
</template>

<script>
import BasePagination from "@/components/common/BasePagination";
import XoaGroupThuocNguoiDungModal from "@/components/pages/quan-tri-he-thong/group/XoaGroupThuocNguoiDungModal";
import DanhSachGroupKhongThuocNguoiDung from "@/components/pages/quan-tri-he-thong/group/DanhSachGroupKhongThuocNguoiDung";

import {
  ROUTE_NAME,
  MENU_ROUTE_NAME,
  BANG_VAI_TRO,
  BO_QUA_BUTTON_LABEL,
} from "@/constants/constants";
import { XOA_GROUP_THUOC_NGUOI_DUNG_THANH_CONG } from "@/constants/message";
import _cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import { hasPermissionUser } from "@/utils/permissionUtils";
import { PERMISSION_NAME } from "@/constants/constants";

export default {
  name: "DanhSachGroupTheoNguoiDung",
  components: {
    XoaGroupThuocNguoiDungModal,
    DanhSachGroupKhongThuocNguoiDung,
    BasePagination,
  },
  data() {
    return {
      PERMISSION_NAME,
      MENU_ROUTE_NAME: `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}`,
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      requestInformation: {
        pageSize: 10,
        pageIndex: 1,
      },
      totalPages: 0,
      totalRows: 0,
      requestInternalForm: {},
      isLoadingTable: true,
      deletedId: null,
      nguoiDungId: null,
      danhSachIdGroupDaChon: [],
      danhSachIdGroupMuonXoa: [],
      danhSachIdGroup: [],
      selectAllRowsInPage: false,
      selectedGroup: [],
    };
  },
  props: {
    readonly: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | null,
      required: false,
    },
    chiTietNguoiDung: {
      type: Object,
      required: true,
    },
    appId: {
      type: String,
      default: null,
    },
  },
  watch: {
    appId: {
      handler() {
        this.layDanhSachGroup();
      },
      deep: true,
    },
    danhSachGroup: {
      handler() {
        this.danhSachIdGroup = this.layDanhSachIdGroup(this.danhSachGroup);
        this.totalPages = this.danhSachGroup.totalPage;
        this.totalRows = _isNil(this.danhSachGroup.totalCount)
          ? 0
          : this.danhSachGroup.totalCount;
      },
      immediate: true,
    },

    selectAllRowsInPage: {
      handler() {
        this.clickSelectAllRowsInPage();
      },
    },
    chiTietNguoiDung: {
      handler() {
        if (!_isNil(this.chiTietNguoiDung)) {
          this.nguoiDungId = this.chiTietNguoiDung.id;
          this.layDanhSachGroup();
        }
      },
    },
    selectedGroup: {
      handler() {
        this.danhSachIdGroupDaChon = this.selectedGroup.map((x) => x.id);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      danhSachGroup: "user/danhSachGroupTheoNguoiDung",
      danhSachApp: "app/tatCaApp",
    }),
    danhSachGroupNoiBo() {
      return this.layDanhSachGroupNoiBo(this.danhSachGroup);
    },
    fieldName() {
      return this.getFieldName();
    },
    hasPageData() {
      return !_isEmpty(this.danhSachGroup);
    },
  },
  methods: {
    hasPermissionUser,
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachGroup();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachGroup();
    },
    moFormThemDanhSachGroup() {
      this.$bvModal.show("them-group-nguoi-dung-modal");
    },
    xoaDanhSachGroupThuocNguoiDung() {
      const $vm = this;
      let payload = {
        userId: this.nguoiDungId,
        userCanBoDepartmentId: this.chiTietNguoiDung.userCanBoDepartmentId,
        groupIds: this.danhSachIdGroupMuonXoa,
        permissionIds: [],
        roleIds: [],
      };
      this.$store
        .dispatch("user/removeMapping", payload)
        .then(() => {
          $vm.$toasted.clear();
          $vm.$toasted.global.showSuccessMessage({
            message: XOA_GROUP_THUOC_NGUOI_DUNG_THANH_CONG,
          });
          this.xoaGroupThanhCong();
        })
        .catch((error) => {
          $vm.$toasted.clear();
          if (
            !_isEmpty(error.response) &&
            error.response.data.Errors.length > 0
          ) {
            $vm.$toasted.global.showErrorMessage({
              message: error.response.data.Errors[0].Description,
            });
          }
        });
    },
    xoaGroupThanhCong() {
      this.danhSachIdGroupDaChon = [];
      this.selectedGroup = [];
      this.layDanhSachGroup();
    },
    themGroupVaoNguoiDungThanhCong() {
      this.$bvModal.hide("them-group-nguoi-dung-modal");
      this.layDanhSachGroup();
    },
    layDanhSachGroup() {
      if (this.chiTietNguoiDung.userCanBoDepartmentId) {
        const payload = {
          UserCanBoDepartmentId: this.chiTietNguoiDung.userCanBoDepartmentId,
          AppId: this.appId,
          UserId: this.nguoiDungId,
          ...this.requestInternalForm,
          ...this.requestInformation,
        };
        this.isLoadingTable = true;
        this.$store
          .dispatch("user/layDanhSachGroupTheoNguoiDung", payload)
          .then((res) => {
            this.isLoadingTable = false;
          })
          .catch((err) => {});
      } else {
        this.$store.dispatch("user/layDanhSachGroupTheoNguoiDung", {
          isReset: true,
        });
        this.isLoadingTable = false;
      }
    },
    layDanhSachGroupNoiBo(danhSachGroup) {
      if (_isEmpty(danhSachGroup)) {
        return [];
      }
      return danhSachGroup.items.map((item, index) => {
        return {
          checkbox: null,
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          name: _isNil(item.name) ? "" : item.name,
          code: _isNil(item.code) ? "" : item.code,
          description: _isNil(item.description) ? "" : item.description,
          appName: _isNil(item.appName) ? "" : item.appName,
          id: item.id,
          thaoTac: null,
        };
      });
    },
    layDanhSachIdGroup(danhSachGroup) {
      if (_isEmpty(danhSachGroup)) {
        return [];
      }
      return danhSachGroup.items.map((item) => item.id);
    },
    goToDetail(id) {
      this.$router.push({
        path: `${ROUTE_NAME.QUAN_TRI_HE_THONG.NAME}${ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME}/${id}/xem`,
      });
    },
    moFormXoaGroup(id) {
      this.danhSachIdGroupMuonXoa = [id];
      this.$bvModal.show("xoa-group-thuoc-nguoi-dung");
    },
    moFormXoaDanhSachGroup() {
      this.danhSachIdGroupMuonXoa = _cloneDeep(this.danhSachIdGroupDaChon);
      this.$bvModal.show("xoa-group-thuoc-nguoi-dung");
    },
    getFieldName() {
      if (_isEmpty(this.danhSachGroupNoiBo)) {
        return [];
      }
      return Object.keys(this.danhSachGroupNoiBo[0])
        .filter((key) => key !== "id")
        .map((key) => {
          return {
            key: key,
            label: BANG_VAI_TRO[key],
            tdClass: ["stt"].includes(key) ? "center" : "",
          };
        });
    },
  },
};
</script>
